import { useState } from "react";
import Header from "../components/Header";
import api from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [stage, setStage] = useState("request");

  const onRequest = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post("/auth/forgot", { email: email.trim() });
      if (r.data.dev_token) {
        setToken(r.data.dev_token);
        toast.success("Reset token issued (dev mode)");
        setStage("reset");
      } else {
        toast("If that email exists, a reset link will be issued.");
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  };

  const onReset = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Min 8 characters");
      return;
    }
    try {
      await api.post("/auth/reset", { token, password });
      toast.success("Password updated. Sign in.");
      window.location.href = "/auth?mode=login";
    } catch (e) {
      toast.error(e.response?.data?.detail || "Reset failed");
    }
  };

  return (
    <>
      <Header minimal />
      <div className="lq-container page-enter" style={{ paddingTop: 56 }}>
        <div className="auth-card">
          <div className="eyebrow">— Recover Account</div>
          <h2 className="serif" style={{ fontSize: 36, lineHeight: 1.05, margin: "8px 0 14px" }}>Forgot password</h2>

          {stage === "request" && (
            <form onSubmit={onRequest}>
              <p style={{ color: "var(--text-mute)", fontSize: 13.5, marginBottom: 18 }}>
                Enter your email — we'll show a reset token here (dev mode, no email service in v1).
              </p>
              <div style={{ marginBottom: 14 }}>
                <label className="label">Email</label>
                <input type="email" className="lq-input" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
              </div>
              <button className="btn btn-primary btn-block" data-testid="forgot-submit">Issue reset token →</button>
            </form>
          )}

          {stage === "reset" && (
            <form onSubmit={onReset}>
              <div className="callout">
                <strong>Dev token:</strong> <code>{token}</code>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label className="label">New Password</label>
                <input type="password" className="lq-input" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="reset-password" />
              </div>
              <button className="btn btn-primary btn-block" data-testid="reset-submit">Set new password →</button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
